export { PromoBar } from './ui/promo-bar';
